export default __webpack_public_path__ + "static/media/Prithvi.9db175fb.jpg";